import Mark from './Mark';

// §2.6 Portal Top bar (non-review Portal pages): mark + wordmark + one action.
export default function TopBar({ action }) {
  return (
    <header className="ui ui-topbar">
      <Mark wordmark />
      {action}
    </header>
  );
}
